import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';

import type { Parking } from 'src/features/parkingManagement/types/parking';
import type { GeneralAxiosError } from 'src/types/errors';

export const updateParkingFormData = (formData: FormData): Promise<Parking> => {
    const parkingId = formData.get('parkingId');
    if (!parkingId || typeof parkingId !== 'string') {
        return Promise.reject(new Error('Missing parkingId in FormData'));
    }
    return axios.patch(`/parkings/${parkingId}/`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const useUpdateParkingFormData = (
    options?: Omit<UseMutationOptions<Parking, GeneralAxiosError<Parking>, FormData>, 'mutationFn'>,
) =>
    useMutation({
        mutationFn: updateParkingFormData,
        ...options,
    });
